export enum KeyboardType {
  QWERTY = 'qwerty',
  ABCDEF = 'abcdef',
}
export type KeyboardConfigLine = string[]
export type KeyboardConfig = KeyboardConfigLine[]
export type KeyboardConfigKey = `${KeyboardType}`
export type KeyboardConfigs = {
  [key in KeyboardConfigKey]: KeyboardConfig
}

export type SidebarButton = {
  icon?: string
  text?: string
  onClick: () => void
}
export type RightPanelButtonsConfig = SidebarButton[]
export type BottomPanelButtonsConfig = SidebarButton[]
export type KeyboardProps = {
  onSelect?: (key: string) => void
  bottomPanelButtonsConfig?: BottomPanelButtonsConfig
  rightPanelButtonsConfig?: RightPanelButtonsConfig
  focusIdPrefix?: string
}
export type Position = {
  row: number
  col: number
}
export type KeyboardLayoutProps = {
  config: KeyboardConfig
  onSelect: (key: string) => void
  type: KeyboardConfigKey
  onGridMove: (pos: Position) => void
  defaultFocusRow: number
  defaultFocusColumn: number
  focusIdPrefix?: string
}
export type KeyboardBottomActionBarProps = {
  config: BottomPanelButtonsConfig
  focusIdPrefix?: string
}
export type KeyboardRightActionBarProps = {
  onMove: (e: MoveEvent) => void
  defaultFocusChild: number
  config: RightPanelButtonsConfig
}
